export const type = 'SET_PID';

export const setPid = (data) => ({
  data,
  type,
});
